































































































    import {Component, Ref, Vue} from 'vue-property-decorator';
    import Header from '@/app/components/Header.vue';
    import jsQR from 'jsqr';
    import Footer from '@/app/components/Footer.vue';

    @Component({
        components: {Footer, Header},
    })
    export default class HomeContainer extends Vue {
        public surveyCode = '';
        public isScanEnabled = false;
        public stream: MediaStream | null = null;

        @Ref('preview')
        public video!: HTMLVideoElement;

        @Ref('canvas')
        public canvasElement!: HTMLCanvasElement;

public async scan() {
    this.isScanEnabled = true;
    this.stream = await navigator.mediaDevices.getUserMedia({audio: false, video: {facingMode: 'environment'}});
    this.video.srcObject = this.stream;
    this.video.setAttribute('playsinline', true as any); // required to tell iOS safari we don't want fullscreen
    await this.video.play();
    requestAnimationFrame(this.tick);
}

        private tick() {
            if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
                const ctx = this.canvasElement.getContext('2d');
                if (ctx) {
                    this.canvasElement.height = this.video.videoHeight;
                    this.canvasElement.width = this.video.videoWidth;
                    ctx.drawImage(this.video, 0, 0, this.canvasElement.width, this.canvasElement.height);
                    const imageData = ctx.getImageData(0, 0, this.canvasElement.width, this.canvasElement.height);
                    const code = jsQR(imageData.data, imageData.width, imageData.height, {
                        inversionAttempts: 'dontInvert',
                    });
                    if (code) {
                        this.surveyCode = code.data
                            .replace(location.origin, '')
                            .replace('https://baloise.github.io', '')
                            .replace('/this-or-that', '')
                            .replace('/index.html', '')
                            .replace('#/', '')
                            .replace('/vote', '')
                            .replace(/\//g, '');
                        if (this.stream) {
                            this.stream.getTracks().forEach(value => value.stop());
                        }
                        this.isScanEnabled = false;
                    }
                }
            }
            requestAnimationFrame(this.tick);
        }

        public create() {
            this.$router.push('create');
        }

        public vote() {
            this.$router.push(this.surveyCode + '/vote');
        }

        public manageSurvey() {
            this.$router.push(this.surveyCode + '/admin');
        }
    }
